<template>

</template>

<script>
import VueEventBus from '../../vue-event-bus';

import { mapState, mapGetters } from 'vuex';
export default {
    name: 'rosterbackup',
    components: {
    },
    data () {
        return {
           
            
            showDetail: false,
            
            
        }
    },
    computed: {
        ...mapGetters(['planShiftMap', 'rosterFromTo', 'storeId', 'spotMap', 'rosterBackupMap', 'loggedIn', 'userInfo']),
        
            
    },
    watch: {
        rosterResultFromTo(newVal, oldVal) {
            this.showDetail = false;
        },
        storeId(newVal, oldVal) {   
            this.showDetail = false;
        },
        
    },
    created: function () {
            //listen to vue eventbus for events from wizard and from vertx eventbus
            VueEventBus.$on("openRosterBackup", this.OpenLoadMenu);
            VueEventBus.$on("saveRosterBackup", this.OpenSaveMenu);
            VueEventBus.$on("autosaveRosterBackup", this.AutoSave);
            
    },
    mounted: function() {
        
        
        
        
    },
    beforeDestroy() {
        VueEventBus.$off("openRosterBackup", this.OpenLoadMenu);
        VueEventBus.$off("saveRosterBackup", this.OpenSaveMenu);
        VueEventBus.$off("autosaveRosterBackup", this.AutoSave);
       
        
        
    },
  // methods that implement data logic.
  methods: {
    OpenLoadMenu(){
        let view = this;
        this.refresh()
        .then(data => {
            view.showDetail = true;
            view.OpenRosterBackupPopup();
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'))
            console.log(error)
        }); 
        
    },
    OpenSaveMenu(){
        let view = this;
        this.refresh()
        .then(data => {
            view.OpenNewRosterBackupPopup();
            
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'))
            console.log(error)
        }); 
        
    },
    AutoSave(){
        let view = this;
        this.refresh()
        .then(data => {
            let item = {
                name: "Autosave"
            }
            view.CreateRosterBackup(item, true);
            
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'))
            console.log(error)
        }); 
        
    },
    
    refresh(force=false){
        let view = this;
        if (view.$store.state.jwt != undefined && view.$store.state.storeId != undefined && view.$store.state.rosterFromTo != null  && view.$store.state.rosterFromTo.from != null && view.$store.state.rosterFromTo.to != null) {
            return view.$helpers.GetSpotMap(force).then(map  => {
                return view.$helpers.GetPlanShiftMap(force);
            }).then(map => {
                return  view.$helpers.GetRosterBackupMap(force);
            })
        } else {
            return new Promise((resove, reject) => {
                reject("Kein JWT token")
            })
        }
    },
    OpenRosterBackupPopup(){
        let view = this;
        
        let state =  {
            spotMap: this.spotMap,
            planShiftMapMap: this.planShiftMap,
            rosterBackupMap: this.rosterBackupMap
        }    
        view.$helpers.OpenPopup({
            elRelative: null,
            type: 'rosterbackupoverview',
            componentState: state,
            expanded: true,
            centered: true,
            scrolling: true,
            remainAfterSelect: false,
            width: '60vw',
            header: 'Gesicherte Dienstpläne',
            customEventName:"modified-rosterbackupoverview",
            customEventHandler:(data) => { 

            }
        });
    },
    OpenNewRosterBackupPopup(){
        let view = this;
        
        let dataEntries = [
            {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: ''},
        ];
        

        this.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            componentState: {
                entries: dataEntries,
                selectCallback: function (item) {
                    view.CreateRosterBackup(item);
                }
            },
            header: this.$t('roster.main.saveRoster'),
            expanded: true,
            centered: true,
        });

    },
    CreateRosterBackup(item, filledOnly = false){
        let view = this;
                
        
        let shifts = Object.values(this.planShiftMap).filter(shift => {
                        let shiftFrom = view.$helpers.getMomentFromStringTZ(shift.from);
                        if(filledOnly){
                            return (shiftFrom.month() == this.rosterFromTo.month) && shift.employeeId != null;
                        } else {
                            return (shiftFrom.month() == this.rosterFromTo.month);
                        }
                        
                    });
        if(shifts.length > 0){
            let url = '/api/sec/rosterbackup';

            let params= {
                storeId: this.storeId,
            }

            let payload = {
                storeId: this.storeId,
                creator: this.userInfo.id,
                creatorName: this.userInfo.firstname+" "+this.userInfo.lastname,
                creationDate: this.$helpers.getMomentTZ().format(),
                name: item.name,
                month: this.rosterFromTo.month+1,
                year: this.rosterFromTo.year,
                shifts: shifts

            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let backup = response.data.data;
                view.$store.commit("setRosterBackupMapEntry", backup);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.main.rosterSaved'));
                
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.saveRosterError'));
            });
        } else {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.nothingToSave'));
        }            
        
    },
    

  }

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>


</style>
